export default __webpack_public_path__ + "static/media/sad.3ca8b131.png";